module.exports = __webpack_public_path__ + "static/media/Shriya_Kale.23b93cdf.jpg";